<div class="dashboard">
  <iu-favorite-group-ui (itemClicked)="openTab($event)"></iu-favorite-group-ui>
  <iu-widget-group-ui (itemClicked)="openTab($event)"></iu-widget-group-ui>
</div>
